import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {Principal} from 'src/app/core';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import {IInsuranceCompanyMySuffix} from 'src/app/shared/model/insurance-company-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';


@Component({
    selector: 'jhi-insurance-company-my-suffix-detail',
    templateUrl: './insurance-company-my-suffix-detail.component.html'
})
export class InsuranceCompanyMySuffixDetailComponent implements OnInit {
    insuranceCompany: IInsuranceCompanyMySuffix;
    signatureUrl: any;
    imageToShow: any;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;

    constructor(
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private clauseExtensionMySuffixService: ClauseExtensionMySuffixService,
        private languageChangeService: LanguageChangeService,
        private jhiAlertService: JhiAlertService
    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
     }

    ngOnInit() {
        this.principal.sortColumn = "priority";
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ insuranceCompany }) => {
            this.insuranceCompany = insuranceCompany;

            console.log('$$$$$$$$', this.insuranceCompany);

            if (this.insuranceCompany.signature && this.insuranceCompany.signature.fileId) {
                this.clauseExtensionMySuffixService.downloadFileService(this.insuranceCompany.signature.fileId).subscribe(
                    response => {
                        this.createImageFromBlob(response);
                    },
                    err => {
                        console.log(err);
                        this.jhiAlertService.error("File not found");
                    }
                );
            }
        });

    }

    previousState() {
        window.history.back();
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    createImageFromBlob(image: Blob) {
        let reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                this.imageToShow = reader.result;
            },
            false
        );

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Insurance Company (' + Obj.name + ') Future Records';
        this.historyType = "INSURANCE_COMPANIES_AUDIT";
        this.historyId = Obj.id;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Insurance Company (' + Obj.name + ') History';
        this.historyType = "INSURANCE_COMPANIES_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
}
